export const selectUserData = (state) => state.auth.userData;
export const selectIsSignedIn = (state) => state.auth.isSignedIn;
export const selectToken = (state) => state.auth.token;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectIsError = (state) => state.auth.isError;
export const selectIsRefreshing = (state) => state.auth.isRefreshing;
